export const productCategories = Object.freeze({
  Produce: 1,
  GrainsAndPastas: 2,
  BreadAndBakery: 3,
  SaucesAndCondiments: 4,
  MeatAndSeafood: 5,
  PlantBasedProteins: 6,
  Pantry: 7,
  Meals: 8,
  DairyAndEggs: 9,
  Beverages: 10,
  Snacks: 11,
  Sweets: 12,
  Kids: 13,
  Supplements: 14,
  CerealAndOats: 15,
  Sides: 16,
});
